import AcceptanceButtons from "./acceptanceButtons"

export default AcceptanceButtons
